import * as api from "../routes/userroutefront";
import axios from "../config/axios";
import key from "../config/config";

/**
 * Stage 6 — KYC (identity verification) API calls.
 *
 * The backend hands back a `hostedFlowUrl` containing short-lived credentials
 * for either a new or resumed inquiry. `oneTimeLink` remains a temporary
 * compatibility fallback for older backend deployments.
 * Nothing about the vendor's credentials passes through here — the browser only
 * ever sees short-lived, single-use handles the backend minted.
 */
export const createKycSession = async (captchaToken, redirectUri) => {
  try {
    const respData = await axios({
      url: key.API_URL + api.kycSession,
      method: "post",
      data: { captchaToken, redirectUri },
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
      token: respData?.data?.token,
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message,
      code: err?.response?.data?.code,
      details: err?.response?.data?.details,
    };
  }
};

export const getMyKycStatus = async () => {
  try {
    const respData = await axios({
      url: key.API_URL + api.kycStatus,
      method: "get",
      params: { _: Date.now() },
      headers: { "Cache-Control": "no-cache" },
    });
    return { status: respData?.data?.status, result: respData?.data?.result };
  } catch (err) {
    return { status: false, result: null };
  }
};

/**
 * Asks the backend to re-read the verification from the vendor. Called when the
 * user returns from the hosted flow, so their status is right even if the
 * vendor's webhook is late or was dropped.
 */
export const refreshKycStatus = async () => {
  try {
    const respData = await axios({ url: key.API_URL + api.kycRefresh, method: "post" });
    return { status: respData?.data?.status, result: respData?.data?.result };
  } catch (err) {
    return { status: false, result: null };
  }
};
